import React, { forwardRef } from "react";

import "./storeDirectionsMap.scss";

const StoreDirectionsMapComponent = forwardRef<HTMLDivElement>((_, ref) => {
    return (
        <div className={"store-directions-map"}>
            <div className="store-directions-map__map" ref={ref}></div>
        </div>
    );
});

export { StoreDirectionsMapComponent };
